const Config = {
  API_URL: 'https://api.winniearcobaleno.it',
  API_URL_LOCAL: 'http://localhost:3030',
  STORAGE_KEY: 'BABY_PARKING',
  appVersion: require('../../package.json').version
}

export default Config
